import React, { useEffect } from "react";
import { useSelector} from "react-redux";
import { Navbar, PricingPlan } from "../../components";
import { Footer } from "../../containers";
import "./pricing.css";
import BGHeader from "../../assets/bg-header.png";
import Icon2 from "../../assets/picon2.svg";
import { LoadingBar } from "../../components/loading_bar/LoadingBar";
import { publicGetSubscriptionPlans, reset} from "../../features/subscription_plans/subscriptionPlanSlice";
import usePublicResource from "../../core/hooks/usePublicResource";
import { Routes } from "../../core/routes/apiRoutes";



function Pricing() {

	const prepareTableData = (response) => {
		var rows = [];
		const tempData = response.data;
    
		for (let i = 0; i < tempData.length; i++) {
			var item = {
				id: i + 1,
				sn: i + 1,
        icon: Icon2,
				name: tempData[i].name,
				description: tempData[i].description,
				period: tempData[i].period,
				amount: tempData[i].subscription_value,
				status: tempData[i].is_enabled?'active':'disabled',
				slug: tempData[i].slug,
        link: "/get-started",
			};

			rows.push(item);
		}

		return rows;
	};

	const {data, ref} =
		usePublicResource({
			selector: useSelector((state) => state.subscriptionPlan),
			getReducer: publicGetSubscriptionPlans,
			resetReducer: reset,
			renderTableData: prepareTableData,
			routes: {
				getRoute: Routes.getSubscriptionPlansUrl,
			},
		});

	useEffect(() => {
		document.title = "Pricing Plans - Greymate Care";
	}, []);

  const pricingPlansList = data.map((plan) => (
    <div key={plan.id} className="gmc__pricing-plans-item">
      <PricingPlan plan={plan}  />
    </div>
  ));

	return (
		<>
      <LoadingBar ref={ref} shadow={true} />
			<div className="gmc__pricing-background">
				<Navbar />
				<div
					className="gmc__pricing__header section__padding section__bg__lines"
					style={{
						backgroundImage: `url(${BGHeader})`,
					}}
				>
					<h1 className="section__heading">
						Choose a care plan that suits your <br />
						circumstances{" "}
					</h1>
					<p className="section__desc">
						Get a caregiver from as little as N2500
					</p>
				</div>
			</div>

			<div className="section__padding gmc__pricing-plans">
				{pricingPlansList}
			</div>
			<Footer />
		</>
	);
}

export default Pricing;
